import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './styles.scss';
import i18n from './utils/i18n';
import Cookies from 'js-cookie';
import enTranslations from './locales/en.json';
import frTranslations from './locales/fr.json';
import deTranslations from './locales/de.json';
import nlTranslations from './locales/nl.json';
import ruTranslations from './locales/ru.json';
import zhTranslations from './locales/zh.json';

import UserBlock from './UserBlock';
import MyBids from './MyBids';
import MyAccount from './MyAccount';
import Myfavorites from './MyFavorites';
import Register from './Register';
import Login from './Login';
import ForgotPassword from './ForgotPassword';
import { ChakraProvider } from '@chakra-ui/react';
import { ConfigProvider } from './utils/Config';
import AuthWrapper from './utils/AuthWrapper';
import packageJson from '../package.json';
import UserInterests from './UserInterests';

// Log version information
console.log(`Circuit User UI Version: ${packageJson.version}`);
console.log(`Build Time: ${new Date().toISOString()}`);

// Load translation resources
i18n.addResourceBundle('en', 'translation', enTranslations, true, true);
i18n.addResourceBundle('fr', 'translation', frTranslations, true, true);
i18n.addResourceBundle('de', 'translation', deTranslations, true, true);
i18n.addResourceBundle('nl', 'translation', nlTranslations, true, true);
i18n.addResourceBundle('ru', 'translation', ruTranslations, true, true);
i18n.addResourceBundle('zh', 'translation', zhTranslations, true, true);

// Set language based on cookie
let prefLanguage = Cookies.get('pref-browser-lang');
if (prefLanguage === 'zh-hans') {
  prefLanguage = 'zh';
}
const supportedLanguages = ['en', 'fr', 'de', 'nl', 'ru', 'zh']; // Make sure this matches your supported languages

if (prefLanguage && supportedLanguages.includes(prefLanguage)) {
  i18n.changeLanguage(prefLanguage);
} else {
  // If no valid cookie is set, use the browser's language
  const browserLang = navigator.language.split('-')[0]; // e.g., 'en-US' becomes 'en'
  if (supportedLanguages.includes(browserLang)) {
    i18n.changeLanguage(browserLang);
  } else {
    i18n.changeLanguage('en'); // fallback to English
  }
}
const userBlockContainer = document.getElementById('user-block');
const myBidsContainer = document.getElementById('my-bids');
const myAccountContainer = document.getElementById('my-account');
const myFavoritesContainer = document.getElementById('my-favorites');
const myRegisterContainer = document.getElementById('register');
const myLoginContainer = document.getElementById('login');
const myForgotPasswordContainer = document.getElementById('forgotpassword');
const myUserInterestsContainer = document.getElementById('my-interests');


const renderComponent = (container, Component, requireAuth = false) => {
  if (container) {
    const root = createRoot(container);
    root.render(
      <ChakraProvider resetCSS={false}>
        <ConfigProvider>
          {requireAuth ? (
            <AuthWrapper>
              <Component/>
            </AuthWrapper>
          ) : (
            <Component/>
          )}
        </ConfigProvider>
      </ChakraProvider>
    );
  }
};

renderComponent(myRegisterContainer, Register);
renderComponent(myLoginContainer, Login);
renderComponent(myForgotPasswordContainer, ForgotPassword);
renderComponent(userBlockContainer, UserBlock);
renderComponent(myBidsContainer, MyBids, true);
renderComponent(myAccountContainer, MyAccount, true);
renderComponent(myUserInterestsContainer, UserInterests);
renderComponent(myFavoritesContainer, Myfavorites, true);
